module.exports = __webpack_public_path__ + "img/oficina.9a8fd66e.jpg";